export type CustomDomainCluster = {
  clusterId: string;
  clusterSlug: `ci_${string}`;
};

/**
 * Custom payment domains and the cluster they represent.
 *
 * Hostnames must be lowercase and must not include a protocol, path, or port.
 * Add future custom domains here; their cluster IDs are automatically included
 * in the client-side cluster allowlist.
 */
export const CUSTOM_DOMAIN_CLUSTERS: Readonly<
  Record<string, CustomDomainCluster>
> = {
  "pay.carmichaelfrost.com": {
    clusterId: "10654",
    clusterSlug: "ci_RFdKY0luRGM2QmhVUVpo",
  },
  "pay.everestbusinessfunding.com": {
    clusterId: "10435",
    clusterSlug: "ci_RFdIYUpTYm1zUGN5QXpo",
  },
  "pay.vangardegroup.com": {
    clusterId: "10567",
    clusterSlug: "ci_RFdJZExvQmp1cUVkUGk1",
  },
  "pay.lincolnandmorgan.com": {
    clusterId: "10572",
    clusterSlug: "ci_RFdJZUdOQU02Nkk1bmxB",
  },
  "pay.plumeriacredit.com": {
    clusterId: "11124",
    clusterSlug: "ci_RFhFWkltMVFNeHZ0TnVV",
  }
};

export const normalizeHostname = (hostname: string): string =>
  hostname.trim().toLowerCase().replace(/\.$/, "");

export const getCustomDomainCluster = (
  hostname: string
): CustomDomainCluster | null =>
  CUSTOM_DOMAIN_CLUSTERS[normalizeHostname(hostname)] || null;
